import { HttpHeader } from '../utils/HttpHeader';
import { HttpRequester } from '../utils/HttpRequester';
import { Urls } from "../utils/Urls";
import { TokenService } from './TokenService';
export class OrderInvoiceService{
    private static links = Urls.URLS();
    private static requester = HttpRequester.httpRequester();
    private static headers = new HttpHeader();
    public static async downloadOrderInvoice(transactionId:number):Promise<Blob>{
        const url = this.links.getOrderInvoiceUrl(transactionId);
        const token = TokenService.getToken();
        this.headers.addAuthHeader(token);
        return await this.requester.getFile(url,this.headers);
    }
}